module.exports = __webpack_public_path__ + "img/back-to-player-icon.556aa10b.svg";